const t = {
  name: "UpliftAuthenticate",
  dimensions: { width: 24, height: 24 },
  content: `
    <svg>
      <path d="M17 2H22V7H24V0H17V2Z" fill="currentColor"/>
      <path d="M15.8875 10.5871L10.9404 15.5342L8.11328 12.7071L9.52749 11.2929L10.9404 12.7057L14.4733 9.17285L15.8875 10.5871Z" fill="currentColor"/>
      <path d="M13 4V2H11.5C5.69772 2 1 6.69772 1 12.5C1 18.3023 5.69772 23 11.5 23C17.3023 23 22 18.3023 22 12.5V11H20V4H13ZM13 6H18V11H20V12.5C20 17.1977 16.1977 21 11.5 21C6.80228 21 3 17.1977 3 12.5C3 7.80228 6.80228 4 11.5 4H13V6Z" fill="currentColor"/>
    </svg>
  `
};
export {
  t as UpliftAuthenticate
};
